import { ParsedQuery } from 'query-string';
import type { DocumentReference } from '../../../../types/file-delivery/FileDelivery';

export const getDesignFromUrl = (query: ParsedQuery): DocumentReference[] => {
  const documentReferenceUrl = typeof query.documentReferenceUrl === 'string' ? query.documentReferenceUrl : undefined;
  const documentReferences = query.documentReferences
    ? JSON.parse(query.documentReferences as string) as DocumentReference[]
    : [];

  // Multiple designs uses the documentReferences array, otherwise fallback to the documentReferenceUrl
  return documentReferences?.length > 0 ? documentReferences : [{
    documentReferenceUrl,
    quantity: 1, // Default quantity
  }] as DocumentReference[];
};
